(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-duo-switch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alc-duo')) {
  customElements.define('alc-duo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-duo-tab]');
        const swatch = event.target.closest('[data-duo-swatch]');
        if (tab && this.contains(tab)) this.selectTab(tab);
        if (swatch && this.contains(swatch)) this.selectColor(swatch);
      });
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-duo-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = Array.from(this.querySelectorAll('[data-duo-tab]'));
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectTab(tabs[index]);
        tabs[index].focus();
      });
    }
    selectTab(tab) {
      const current = this.querySelector('[data-duo-panel]:not([hidden]) [aria-pressed="true"]');
      this.querySelectorAll('[data-duo-tab]').forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-duo-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.duoPanel !== tab.dataset.duoTab;
        if (!panel.hidden && current) {
          const match = Array.from(panel.querySelectorAll('[data-duo-swatch]')).find((item) => item.dataset.colorKey === current.dataset.colorKey);
          if (match) this.selectColor(match);
        }
      });
    }
    selectColor(swatch) {
      const panel = swatch.closest('[data-duo-panel]');
      const image = panel.querySelector('.alc-duo__image');
      image.srcset = swatch.dataset.srcset;
      image.src = swatch.dataset.image;
      image.alt = swatch.dataset.alt;
      panel.querySelectorAll('[data-duo-link]').forEach((link) => { link.href = swatch.dataset.url; });
      panel.querySelector('[data-duo-color]').textContent = swatch.dataset.color;
      const price = panel.querySelector('[data-duo-price]');
      price.textContent = swatch.dataset.price;
      if (swatch.dataset.compare) {
        const compare = document.createElement('s');
        compare.textContent = swatch.dataset.compare;
        price.append(' ', compare);
      }
      panel.querySelectorAll('[data-duo-swatch]').forEach((item) => { item.setAttribute('aria-pressed', String(item === swatch)); });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
